import './ProfileInfo.css';
import { useEffect, useState } from 'react';
import FadeIn from '../../utils/fadein';
import { getSeniorityLevels, getUserProfile, getDepartments, updateUser, updateUserProfile, updatePersonaType, addPhoneNumber, hRefreshToken, getCountries, addUrlSlug } from '../../utils/api';
import { getRole, refresh } from '../../services/auth.service';
import { IKImage, IKContext, IKUpload } from 'imagekitio-react'
import { Helmet } from "react-helmet";
import iconCompanyDefault from '../../assets/companylogos/default.png';
import { Routes, Route, Link, Outlet } from 'react-router-dom';
import moment from 'moment-timezone';
import { FaAsterisk, FaCheck, FaGlobe } from 'react-icons/fa';

const ProfileInfo = ({ userType }) => {
  const [user, setUser] = useState({});
  const [showTimezone, setShowTimezone] = useState(true);
  const [seniority, setSeniority] = useState([]);
  const [selectedSeniority, setSelectedSeniority] = useState('');
  const [selectedTimezone, setSelectedTimezone] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [newFirstName, setNewFirstName] = useState('');
  const [newLastName, setNewLastName] = useState('');
  const [newJobTitle, setNewJobTitle] = useState('');
  const [linkedin, setLinkedin] = useState('');
  const [newDepartment, setNewDepartment] = useState('');
  const [newSeniority, setNewSeniority] = useState(0);
  const [newTimezone, setNewTimezone] = useState('');
  const [newPhoneNumber, setNewPhoneNumber] = useState('');
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(0);
  const [departmentId, setDepartmentId] = useState(0);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const imageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const [fileName, setFileName] = useState('');
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(0);
  const [timezones, setTimezones] = useState([]);
  const [biography, setBiography] = useState('');
  const [slug, setSlug] = useState('');
  const [isSlugAvailable, setIsSlugAvailable] = useState(true);
  const [loadedProfile, setLoadedProfile] = useState(false);

      async function loadUserProfile() {
      let response = await getUserProfile('');

      if (response.success) {
        let data = response.data;

        setUser(response.data);
        setNewFirstName(data.first_name);
        setNewLastName(data.last_name);
        setNewJobTitle(data.job_title);
        setSelectedSeniority(data.seniority);
        setSelectedTimezone(data.timezone);
        setNewSeniority(data.seniority_level_id);
        setNewDepartment(data.department);
        setNewPhoneNumber(data.phone_number);
        setNewTimezone(data.tz);
        setLinkedin(data.linkedin_url);
        setDepartmentId(data.department_id);
        setSelectedCountry(data.country_id);
        setBiography(data.biography || '');
        setSlug(data.slug || '');
        setLoadedProfile(true);
      }
    }

  useEffect(() => {
    async function loadSeniority() {
      let data = await getSeniorityLevels();
      setSeniority(data.data);
    }

    async function loadCountries() {
      let res = await getCountries();

      if (res.success) {
        setCountries(res.data);
      }
    }

    async function loadTimezones() {
      const timezoneList = moment.tz.names();
      setTimezones(timezoneList);
    }

    // based on users current role as buyer or seller
    async function loadUserProfile() {
      let response = await getUserProfile('');

      if (response.success) {
        let data = response.data;

        setUser(response.data);
        setNewFirstName(data.first_name);
        setNewLastName(data.last_name);
        setNewJobTitle(data.job_title);
        setSelectedSeniority(data.seniority);
        setSelectedTimezone(data.timezone);
        setNewSeniority(data.seniority_level_id);
        setNewDepartment(data.department);
        setNewPhoneNumber(data.phone_number);
        setNewTimezone(data.tz);
        setLinkedin(data.linkedin_url);
        setDepartmentId(data.department_id);
        setSelectedCountry(data.country_id);
        setBiography(data.biography || '');
        setSlug(data.slug || '');

        setLoadedProfile(true);
      }
    }

    async function loadDepartments() {
      let data = await getDepartments();
      if (data.data) {
        setDepartments(data.data);
      }
    }

    loadTimezones();
    loadSeniority();
    loadUserProfile();
    loadDepartments();
    loadCountries();

    document.title = "LeadrPro - Profile";
  }, []);

  function loadSaveBanner() {
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }


  async function handleSaveBasicInfo() {
    if (newFirstName === '' || newLastName === '') {
      alert("Please provide a valid legal name");
      return;
    }

    let response = await updateUser({
      first_name: newFirstName,
      last_name: newLastName,
      timezone: newTimezone,
      country_id: selectedCountry
    });

    if (response.success) {
      setUser(prevState => ({
        ...prevState, first_name: newFirstName, last_name: newLastName, timezone: newTimezone
      }));

      loadSaveBanner();
    }

    else if (response.status === 403) {
      await refresh();

      let response = await updateUser({
        first_name: newFirstName,
        last_name: newLastName,
        timezone: newTimezone
      });

      if (response.success) {
        setUser(prevState => ({
          ...prevState, first_name: newFirstName, last_name: newLastName, timezone: newTimezone
        }));

        loadSaveBanner();
      }
    }
  }

  async function handleSaveTimezone() {
    let response = await updateUser({ timezone: newTimezone });
    if (response.success) {
      setUser(prevState => ({
        ...prevState, timezone: newTimezone
      }));

      setShowTimezone(false);
      loadSaveBanner();
    }

    else if (response.status === 403) {
      await refresh();

      let response = await updateUser({ timezone: newTimezone });
      if (response.success) {
        setUser(prevState => ({
          ...prevState, timezone: newTimezone
        }));

        setShowTimezone(false);
        loadSaveBanner();
      }
    }
  }


  async function handleSavePhoneNumber() {
    if (newPhoneNumber && newPhoneNumber.length > 0) {
      let response = await addPhoneNumber(newPhoneNumber);
      if (response.success) {
        loadSaveBanner();
      }
    }

    else {
      alert("Must enter a valid number");
    }
  }

  async function handleDepartmentChange(e) {
    setSelectedDepartment(e.target.value);
    setDepartmentId(e.target.value);
  }


  async function onError() {

  }

  function onSuccess(e) {
    setFileName(e.name);
  }

  useEffect(() => {
    // file has been changed
    setUser(prevState => ({ ...prevState, profile_image: fileName }));
    handleSaveLogo();

  }, [fileName]);

  async function handleSaveLogo() {

    if (fileName.length > 0) {
      let res = await updateUserProfile({ profile_image: fileName });

      if (res.success) {
        loadSaveBanner();
      }

      else if (res.status === 403) {
        await refresh();
        let res = await updateUserProfile({ profile_image: fileName });

        if (res.success) {
          loadSaveBanner();
        }
      }
    }
  }

  async function handleSaveWorkInfo() {
    if (newJobTitle === '' || newSeniority === 0 || departmentId === 0) {
      alert("Please fill in all required fields.");
      return;
    }

    let response = await updateUserProfile({
      job_title: newJobTitle,
      seniority_level_id: newSeniority,
      department_id: departmentId,
      biography: biography,
      linkedin_url: linkedin
    });

    if (response.success) {
      setUser(prevState => ({
        ...prevState,
        job_title: newJobTitle,
        seniority_level_id: newSeniority,
        department_id: departmentId
      }));
      loadSaveBanner();
    } else if (response.status === 403) {
      await refresh();
      let response = await updateUserProfile({
        job_title: newJobTitle,
        seniority_level_id: newSeniority,
        department_id: departmentId
      });

      if (response.success) {
        setUser(prevState => ({
          ...prevState,
          job_title: newJobTitle,
          seniority_level_id: newSeniority,
          department_id: departmentId
        }));
        loadSaveBanner();
      }
    }
  }

  async function handleSaveSlug() {
    if (!slug) {
      alert("Please enter a valid URL slug");
      return;
    }

    let response = await updateUserProfile({ slug: slug });
    if (response.success) {
      setUser(prevState => ({
        ...prevState,
        slug: slug
      }));
      loadSaveBanner();
    } else if (response.status === 403) {
      await refresh();
      response = await updateUserProfile({ slug: slug });
      if (response.success) {
        setUser(prevState => ({
          ...prevState,
          slug: slug
        }));
        loadSaveBanner();
      }
    }
  }

    function validateSlug(slug) {
    // regular expression to match a valid slug
    const regex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  
    // check if the slug matches the regular expression
    return regex.test(slug);
  }

   async function handleUrlSubmit(){
      if (slug != null && slug.length > 0){
        let valid = validateSlug(slug.toLocaleLowerCase());
  
        if (valid === false){
          alert("Invalid url format");
          return;
        }
        
        let res = await addUrlSlug(slug.toLowerCase());
  
        if (res.success){
          await loadUserProfile();
          //setUserProfile(prevState => ({
          //  ...prevState, slug: slug}));
  
          //  navigate('/profile/' + slug.toLowerCase());
          loadSaveBanner();
        }
  
        else{
          alert("URL is already taken");
        }
      }
  
      else{
        alert("Must enter a valid url path");
      }
    }

  return (
    <div className="profileinfo">
      <Helmet>
        <meta name="description" content="" />
      </Helmet>

      

<div className="mb-6">
        <Link 
          className='inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 ease-in-out'
          to="/account/home"
        >
          <span className="mr-2">←</span>
          Back
        </Link>
      </div>      <div className="account__header">Profile Info</div>

      <p style={{ margin: '15px 0px' }}>
        Keep your profile up to date with your latest employers information.
      </p>

      <div className='profileinfo__form'>
        <div style={{ textAlign: 'right', fontSize: '12px', fontStyle: 'italic', marginBottom: '10px', color: 'tomato' }}><FaAsterisk /> Required fields</div>

        {/* Basic Info Section */}
        <div className="mb-8 bg-white p-6 rounded-lg shadow-sm">
          {loadedProfile && !user.slug ? (
        <div className="mb-6 bg-purple-50 border border-purple-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <FaGlobe className="text-purple-500 w-5 h-5" />
              <div>
                <h3 className="font-medium text-purple-900">Publish your public profile</h3>
                <p className="text-sm text-purple-700">Choose a custom URL for your public profile</p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="flex items-center">
                <span className="text-gray-500 text-sm mr-2">leadrpro.com/profile/</span>
                <input
                  type="text"
                  className="input !w-40"
                  placeholder="your-name"
                  value={slug}
                  onChange={(e) => setSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-'))}
                />
              </div>
              <button
                className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                onClick={handleUrlSubmit}
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      ) : loadedProfile && (
        <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <FaCheck className="text-green-500 w-5 h-5" />
              <div>
                <h3 className="font-medium text-green-900">Your profile is published!</h3>
                <p className="text-sm text-green-700">
                  View your public profile at{' '}
                  <a 
                    href={`/book-demo/${user.slug}`}
                    className="text-green-800 underline hover:text-green-900"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    leadrpro.com/book-demo/{user.slug}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

          <h2 className="text-xl font-semibold text-gray-900 mb-6">Basic Information</h2>

          <div className=''>
            <div className="text-lg font-medium text-gray-900 mb-4">Profile Picture</div>

            <div className="flex items-start space-x-8">
              <div className="flex-shrink-0">
                <div className="relative group">
                  <div className="w-32 h-32 rounded-full overflow-hidden bg-gray-100 border-2 border-gray-200">
                    {user.profile_image && user.profile_image !== '' ? (
                      <img
                        src={imageUrl + 'profileimages/' + user.profile_image}
                        alt="Profile"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-gray-50">
                        <img
                          src={iconCompanyDefault}
                          alt="Default"
                          className="w-16 h-16 text-gray-400"
                        />
                      </div>
                    )}
                  </div>
                  <div className="absolute inset-0 rounded-full bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <span className="text-white text-sm font-medium">Change Photo</span>
                  </div>
                </div>
              </div>

              <div className="flex-grow space-y-3">
                <div className="text-sm text-gray-600">
                  Upload a professional profile picture to make your profile more personable
                </div>
                <div className="flex items-center space-x-4">
                  <IKContext
                    publicKey="public_Nqch/XuW1fN+NARwogG4qD4gizs="
                    urlEndpoint="https://ik.imagekit.io/ivgrhmd4k"
                    authenticationEndpoint={process.env.REACT_APP_API_BASE_URL + '/imagekit/auth'}
                  >
                    <IKUpload
                      className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-colors"
                      fileName="logo.jpg"
                      folder={"/profileimages"}
                      onError={onError}
                      onSuccess={onSuccess}
                    />
                  </IKContext>
                  {fileName && (
                    <span className="text-sm text-green-600 flex items-center">
                      <FaCheck className="w-4 h-4 mr-1" />
                      Photo uploaded successfully
                    </span>
                  )}
                </div>
                <div className="text-xs text-gray-500">
                  Recommended: Square image, at least 400x400 pixels
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <div className="">
              <div className="">
                <label className="label">First name <span style={{ fontSize: '10px', color: 'tomato' }}><FaAsterisk /></span></label>
                <input type="text" id="txtFirstName" className="input" value={newFirstName} onChange={event => { setNewFirstName(event.target.value); }} placeholder='Enter first name' />
              </div>

              <div className="" style={{ marginTop: "20px" }}>
                <label className="label">Last name <span style={{ fontSize: '10px', color: 'tomato' }}><FaAsterisk /></span></label>
                <input type="text" id="txtLastName" className="input" value={newLastName} onChange={event => { setNewLastName(event.target.value); }} placeholder='Enter last name' />
              </div>

              <div className='mt-2'>
                <div className="label">Country</div>

                <div>
                  <select className='input' id='selectCountry' value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
                    <option>Select country</option>

                    {countries.map(item => (
                      <option value={item.country_id}>{item.display_name}</option>
                    ))}
                  </select>
                </div>

              </div>

              <div className="mt-2">
                <div>
                  <div className="label">Timezone <span style={{ fontSize: '10px', color: 'tomato' }}><FaAsterisk /></span></div>

                  {!showTimezone && (
                    <div className="profileinfo__form-group-current">{newTimezone ? newTimezone : <span className="accountinfo__placeholder">Your timezone.</span>}</div>
                  )}
                </div>

                <div className="profileinfo__edit">
                  <div>

                    <select className='select input' id="defaultTimeZoneId" value={newTimezone} name="defaultTimeZoneId" onChange={(e) => setNewTimezone(e.target.value)}>
                      {timezones.map((timezone) => (
                        <option key={timezone} value={timezone}>
                          {timezone}
                        </option>
                      ))}
                    </select>
                  </div>

                </div>

              </div>

            </div>
          </div>

          <div className='mt-4'>
            <button
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleSaveBasicInfo}
            >
              Save Basic Info
            </button>
          </div>
        </div>

        <div className="mb-8 bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">Work Information</h2>

          <div className="">
            <div className="label">Job Title <span style={{ fontSize: '10px', color: 'tomato' }}><FaAsterisk /></span></div>

            <div className="profileinfo__jobtitle">
              <div>
                <input type="text" id="txtJobTitle" className="input" value={newJobTitle} onChange={event => { setNewJobTitle(event.target.value); }} placeholder='Enter your job title' />
              </div>

            </div>
          </div>

          <div className="mt-2">
            <div className="label">Seniority Level</div>

            <div className="profileinfo__edit">
              <div>
                <select className="input"
                  name='seniority'
                  value={newSeniority}
                  required
                  onChange={(e) => setNewSeniority(e.target.value)}
                >
                  <option>Select seniority</option>
                  {seniority.length > 0 && (
                    seniority.map((item, index) => (
                      <option style={{ fontFamily: "var(--secondary-font)" }} key={index} value={item.seniority_level_id}>
                        {item.name}
                      </option>
                    ))
                  )}
                </select>
              </div>

            </div>
          </div>

          <div className="mt-2">
            <div className="label">Department</div>

            <div>
              <select id='selectDepartment' className='input' onChange={(e) => handleDepartmentChange(e)}>
                <option>Select your department...</option>
                {departments.map((item, index) => (
                  <>
                    {departmentId === item.department_id && (
                      <option key={index} value={item.department_id} selected>{item.name}</option>
                    )}

                    {departmentId !== item.department_id && (
                      <option key={index} value={item.department_id}>{item.name}</option>
                    )}
                  </>
                ))}
              </select>

            </div>
          </div>

          <div className="mt-2">
            <div className="label">Biography</div>
            <div className="profileinfo__edit">
              <div>
                <textarea
                  className="input min-h-[100px] w-full p-3"
                  value={biography}
                  onChange={(e) => setBiography(e.target.value)}
                  placeholder="Tell us about yourself..."
                />
              </div>

            </div>
          </div>

          <div className="mt-2">
            <div className="label">LinkedIn Profile URL</div>

            <div className="profileinfo__edit">
              <div>
                <input type="text" id="txtLinkedin" className="input" value={linkedin} onChange={(e) => setLinkedin(e.target.value)} placeholder="LinkedIn Profile URL" />
              </div>

            </div>
          </div>

          <div className='profileinfo__btn'>
            <button
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleSaveWorkInfo}
            >
              Save Work Info
            </button>
          </div>
        </div>


        <div className="profileinfo__form-group" id="phone">
          <div className="profileinfo__form-group-title">Phone Number</div>

          <div className="profileinfo__edit">
            <div>
              <input type="text" id="txtPhoneNumber" className="input" value={newPhoneNumber} onChange={(e) => setNewPhoneNumber(e.target.value)} placeholder="Enter your phone number" />
            </div>

            <div className='profileinfo__btn'>
              <button
                className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleSavePhoneNumber}
              >
                Save Phone Number
              </button>
            </div>
          </div>
        </div>

      </div>

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className='profileinfo__saved-banner'>
            Profile updated successfully!
          </div>
        </FadeIn>
      )}
    </div>
  )
}

export default ProfileInfo;